export default function BereavementGroupPage () {
    return (
        <div class="flex justify-center min-h-screen">
            <div class="text-center max-w-2xl p-6">
                <h1 className="text-3xl font-bold text-center my-6">Bereavement Group</h1>
                <p class="text-base text-black mb-6">
                    We meet the first Tuesday of each month 10.30 am – 11.30 am in the Community Room, 
                    adjacent to the church, for tea and toast and a chat.  We provide a listening ear to 
                    those who have been bereaved.  Please feel free to come along and stay for as long as you’d like
                </p>
            </div>
        </div>
    )
}